import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight, ShieldCheck, Gift, RefreshCw, Briefcase, Plus, Check } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function PricingSection() {
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const handleBuyClick = () => {
    trackAddToCart();
  };
  const basePrice = 6.99;
  const totalPrice = basePrice + (bump1 ? 9 : 0) + (bump2 ? 9 : 0);
  const hasBumps = bump1 || bump2;
  return <section id="pricing" className="py-24 md:py-32 bg-brown-900 text-cream-50 relative overflow-hidden" data-id="element-177">
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-178"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-179">
        <FadeIn data-id="element-180">
          <p className="text-xl md:text-2xl font-serif italic text-cream-100/80 max-w-2xl mx-auto mb-6 leading-relaxed" data-id="element-181">
            Mañana te vas a despertar, mirarte al espejo, y volver a sentir lo
            mismo:
          </p>
          <div className="max-w-xl mx-auto space-y-4 text-lg text-cream-200/60 mb-6" data-id="element-182">
            <p data-id="element-183">El frizz que no entiendes.</p>
            <p data-id="element-184">La frustración de no saber qué hacer.</p>
            <p data-id="element-185">La vergüenza de que tu pelo no refleje quién eres.</p>
          </div>
          <p className="text-2xl md:text-3xl font-serif text-white mb-4 leading-snug" data-id="element-186">
            Y vas a abrir otra vez el teléfono, buscar otro producto, gastar
            otro dinero…
          </p>
          <p className="text-3xl md:text-4xl font-serif font-medium text-terracotta italic mb-12" data-id="element-187">
            ¿O vas a hacer algo diferente hoy?
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-188">
          <h2 className="text-3xl md:text-4xl font-serif mb-10 text-cream-100" data-id="element-189">
            Deja de repetir el ciclo. <br data-id="element-190" />
            <span className="text-white font-bold" data-id="element-191">Empieza con tu mapa.</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.3} className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-white/10 max-w-2xl mx-auto" data-id="element-192">
          <div className="flex flex-col items-center" data-id="element-193">
            <p className="text-cream-200/50 text-sm mb-6 tracking-wide font-sans" data-id="element-194">
              EL DICCIONARIO DEL CABELLO — GUÍA COMPLETA 1A–4C
            </p>

            <div className="flex items-baseline gap-2 mb-2" data-id="element-195">
              <span className="text-6xl md:text-7xl font-serif font-bold text-white leading-none" data-id="element-196">
                $6<span className="text-4xl md:text-5xl" data-id="element-197">.99</span>
              </span>
              <span className="text-lg text-cream-200/60" data-id="element-198">USD</span>
            </div>

            <p className="text-cream-200/50 mb-10 text-sm" data-id="element-199">
              Pago único • Acceso de por vida
            </p>

            <div className="w-full bg-olive/10 rounded-xl p-4 mb-8 border border-olive/20" data-id="element-200">
              <div className="flex items-center justify-center gap-2 text-cream-100 text-sm" data-id="element-201">
                <Gift className="w-4 h-4 text-olive-light" data-id="element-202" />
                <span data-id="element-203">
                  Incluye <strong className="text-white" data-id="element-204">3 bonos gratis</strong>{' '}
                  valorados en $47: Kit SOS Anti‑Frizz + Lista de Compras
                  Inteligente + Peinados Express
                </span>
              </div>
            </div>

            {/* Order Bumps */}
            <div className="w-full space-y-3 mb-6" data-id="element-205">
              {/* Order Bump 1 */}
              <div className="w-full rounded-xl overflow-hidden border-2 border-terracotta/50 transition-all duration-300" data-id="element-206">
                <div className="bg-terracotta/20 px-4 py-1.5 flex items-center justify-center gap-2" data-id="element-207">
                  <span className="text-terracotta-light text-xs font-bold tracking-wider uppercase" data-id="element-208">
                    Altamente recomendado
                  </span>
                </div>
                <button onClick={() => setBump1(!bump1)} className={`w-full text-left p-4 transition-all duration-300 ${bump1 ? 'bg-terracotta/15' : 'bg-white/5 bump-flash'}`} data-id="element-209">
                  <div className="flex items-start gap-4" data-id="element-210">
                    <div className={`w-5 h-5 rounded border-2 flex items-center justify-center shrink-0 mt-0.5 transition-all duration-200 ${bump1 ? 'bg-terracotta border-terracotta' : 'border-terracotta/40 bg-transparent'}`} data-id="element-211">
                      {bump1 && <Check className="w-3 h-3 text-white" data-id="element-212" />}
                    </div>

                    <div className="w-16 h-20 shrink-0 rounded-lg overflow-hidden border border-terracotta/30 hidden md:block" data-id="element-213">
                      <img src="https://cdn.magicpatterns.com/uploads/u9MSRmgNpjNXp31NPEquek/heylloyd-image-1771038912013.png" alt="Refresh Perfecto Día 2-3" className="w-full h-full object-cover" data-id="element-214" />
                    </div>

                    <div className="flex-1" data-id="element-215">
                      <div className="flex items-center gap-2 mb-1" data-id="element-216">
                        <RefreshCw className="w-4 h-4 text-terracotta-light md:hidden" data-id="element-217" />
                        <span className="font-serif font-bold text-cream-100 text-sm md:text-base" data-id="element-218">
                          Haz que tu cabello dure más de un día (sin lavar)
                        </span>
                      </div>
                      <p className="text-cream-200/50 text-xs leading-relaxed" data-id="element-219">
                        Añade{' '}
                        <strong className="text-cream-200/70" data-id="element-220">
                          Refresh Perfecto Día 2–3 (1A–4C)
                        </strong>{' '}
                        y revive tu cabello en 3–5 minutos: menos frizz, más
                        definición y un plan claro según tu textura. Incluye
                        rutinas express, cantidades exactas, tabla "si pasa X →
                        hago Y" y tarjetas para guardar en el celular.
                      </p>
                      <div className="flex items-center gap-1.5 mt-2" data-id="element-221">
                        <Plus className="w-3 h-3 text-terracotta-light" data-id="element-222" />
                        <span className="text-terracotta-light font-bold text-sm" data-id="element-223">
                          +$9
                        </span>
                        <span className="text-cream-200/40 text-xs" data-id="element-224">
                          (opcional)
                        </span>
                      </div>
                    </div>
                  </div>
                </button>
              </div>

              {/* Order Bump 2 */}
              <div className="w-full rounded-xl overflow-hidden border-2 border-terracotta/50 transition-all duration-300" data-id="element-225">
                <div className="bg-terracotta/20 px-4 py-1.5 flex items-center justify-center gap-2" data-id="element-226">
                  <span className="text-terracotta-light text-xs font-bold tracking-wider uppercase" data-id="element-227">
                    Altamente recomendado
                  </span>
                </div>
                <button onClick={() => setBump2(!bump2)} className={`w-full text-left p-4 transition-all duration-300 ${bump2 ? 'bg-terracotta/15' : 'bg-white/5 bump-flash'}`} data-id="element-228">
                  <div className="flex items-start gap-4" data-id="element-229">
                    <div className={`w-5 h-5 rounded border-2 flex items-center justify-center shrink-0 mt-0.5 transition-all duration-200 ${bump2 ? 'bg-terracotta border-terracotta' : 'border-terracotta/40 bg-transparent'}`} data-id="element-230">
                      {bump2 && <Check className="w-3 h-3 text-white" data-id="element-231" />}
                    </div>

                    <div className="w-16 h-20 shrink-0 rounded-lg overflow-hidden border border-terracotta/30 hidden md:block" data-id="element-232">
                      <img src="https://cdn.magicpatterns.com/uploads/8h2S9NNMkqUMDBshpRJutw/heylloyd-image-1771038922275.png" alt="Kit Viaje & Gym Hair" className="w-full h-full object-cover" data-id="element-233" />
                    </div>

                    <div className="flex-1" data-id="element-234">
                      <div className="flex items-center gap-2 mb-1" data-id="element-235">
                        <Briefcase className="w-4 h-4 text-terracotta-light md:hidden" data-id="element-236" />
                        <span className="font-serif font-bold text-cream-100 text-sm md:text-base" data-id="element-237">
                          Tu plan elegante para días fuera de casa (en 5
                          minutos)
                        </span>
                      </div>
                      <p className="text-cream-200/50 text-xs leading-relaxed" data-id="element-238">
                        Añade el{' '}
                        <strong className="text-cream-200/70" data-id="element-239">
                          Kit Viaje & Gym Hair (1A–4C)
                        </strong>{' '}
                        y sal lista en 5 minutos cuando estás en el gym, en el
                        carro, viajando o con prisa. Incluye kit mínimo de
                        herramientas, mini kit por textura, protocolo
                        anti-humedad, peinados "salvavidas" y checklist
                        imprimible.
                      </p>
                      <div className="flex items-center gap-1.5 mt-2" data-id="element-240">
                        <Plus className="w-3 h-3 text-terracotta-light" data-id="element-241" />
                        <span className="text-terracotta-light font-bold text-sm" data-id="element-242">
                          +$9
                        </span>
                        <span className="text-cream-200/40 text-xs" data-id="element-243">
                          (opcional)
                        </span>
                      </div>
                    </div>
                  </div>
                </button>
              </div>
            </div>

            {/* Dynamic Total */}
            {hasBumps && <div className="w-full bg-white/5 rounded-xl p-4 mb-6 border border-white/10" data-id="element-244">
                <div className="flex items-center justify-between text-sm mb-1" data-id="element-245">
                  <span className="text-cream-200/50" data-id="element-246">
                    Guía El Diccionario del Cabello
                  </span>
                  <span className="text-cream-200/60" data-id="element-247">$6.99</span>
                </div>
                {bump1 && <div className="flex items-center justify-between text-sm mb-1" data-id="element-248">
                    <span className="text-cream-200/50" data-id="element-249">
                      + Refresh Perfecto Día 2–3
                    </span>
                    <span className="text-cream-200/60" data-id="element-250">$9.00</span>
                  </div>}
                {bump2 && <div className="flex items-center justify-between text-sm mb-1" data-id="element-251">
                    <span className="text-cream-200/50" data-id="element-252">
                      + Kit Viaje & Gym Hair
                    </span>
                    <span className="text-cream-200/60" data-id="element-253">$9.00</span>
                  </div>}
                <div className="border-t border-white/10 mt-2 pt-2 flex items-center justify-between" data-id="element-254">
                  <span className="font-bold text-white text-base" data-id="element-255">
                    Total hoy
                  </span>
                  <span className="font-bold text-white text-xl font-serif" data-id="element-256">
                    ${totalPrice.toFixed(2)} USD
                  </span>
                </div>
              </div>}

            <a href="https://evolucionaactivo.com/cart/43902624759894:1" target="_blank" rel="noopener noreferrer" onClick={handleBuyClick} className="w-full md:w-auto px-10 py-5 bg-terracotta hover:bg-terracotta-hover text-white text-xl font-bold rounded-full transition-all transform hover:scale-105 shadow-lg shadow-terracotta/30 flex items-center justify-center gap-3 mb-4 no-underline" data-id="element-257">
              Quiero dejar de adivinar — ${totalPrice.toFixed(2)}
              <ArrowRight className="w-6 h-6" data-id="element-258" />
            </a>

            <p className="text-cream-200/40 text-xs mb-8" data-id="element-259">
              Recibes el PDF completo en tu correo en segundos
            </p>

            <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-cream-200/60" data-id="element-260">
              <div className="flex items-center gap-1.5" data-id="element-261">
                <ShieldCheck className="w-4 h-4 text-olive-light" data-id="element-262" />
                <span data-id="element-263">Descarga segura e inmediata</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-264">
                <Gift className="w-4 h-4 text-olive-light" data-id="element-265" />
                <span data-id="element-266">Checklists + Plan 14 días incluidos</span>
              </div>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.45} className="mt-14 max-w-xl mx-auto" data-id="element-267">
          <p className="text-cream-100 font-serif italic text-xl leading-relaxed" data-id="element-268">
            "Cada día que pasa sin un sistema, es otro día de prueba y error.
            Otro producto. Otra frustración."
          </p>
          <p className="text-cream-200/40 text-sm mt-8" data-id="element-269">
            Compatible con todos los dispositivos (Móvil, Tablet, PC).
          </p>
        </FadeIn>
      </div>
    </section>;
}